<template>
  <div class="introWrap">
    <p class="altitle">{{getData.title}}</p>
    <div>
      <p class="content">{{getData.content}}</p>
    </div>
    <el-row type="flex" justify="space-around">
      <el-col
        v-for="(item,index) in getData.dataFileList"
        :key="index">
        <p>{{item.dataTitle}}</p>
        <span class="enter">{{item.dataDescript}}</span>
        <a :href="item.dataFile"><i>{{$t('heard.report')}}>></i></a>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'paas',
  props: ['getData'],
  data () {
    return {
    }
  },
  created () {},
  mounted () {},
  methods: {
    showData () {
      var data = this.getData
      console.log(data)
    }
  }
}
</script>
<style scoped lang="less">
.introWrap{
   background: url('../../../assets/u473.png');
   height: 9rem;
   padding-top: 0.5rem;
  .content{
	width: 49%;
    height: 3rem;
    margin: 0 auto;
    font-size: 0.3rem;
    text-align: left;
    margin-top: 0.5rem;
   }
   .el-row{
        width: 70%;
        margin: 0 auto;
        img{
            width: 43%;
        }
        p{
            font-weight: 700;
            font-style: normal;
            font-size: 20Px;
        }
        span{
            width: 3rem;
            font-size: 0.25rem;
            margin: 0.5rem 0;
            display: -webkit-inline-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
        i{
            display: block;
        }
   }
}

</style>
